import BlinkingCursor from '@/components/BlinkingCursor';

export default function ThinkingPreview() {
  return (
    <div
      aria-label="Thinking state preview"
      className="relative z-10 mx-auto flex w-full max-w-[42rem] flex-col gap-2 py-3"
    >
      <div className="flex justify-end">
        <div className="user-message-bubble max-w-[84%] rounded-2xl rounded-br-[5px] border border-white/5 bg-[#202b45] px-3.5 py-2.5 text-[13px] leading-5 text-white shadow-none dark:bg-[#2b3650]">
          Which IPMA certification is right for me?
        </div>
      </div>
      <BlinkingCursor />
    </div>
  );
}
